import RolesPage from '../../../components/admin/roles/RolesPage'

export default function Roles() {
  return <RolesPage />
}
